import { isPast, addYears, getYear, getMonth, format, sub } from 'date-fns';
import _orderBy from 'lodash/orderBy';
import { MONTHS } from '../modules/clients/constants';

const getReminderYear = (day, month) => {
  const currentYear = new Date().getFullYear();
  const reminderMonth = MONTHS.indexOf(month);
  const reminderDateCurrentYear = new Date(currentYear, reminderMonth, day);

  const reminderYear = isPast(reminderDateCurrentYear) ? getYear(addYears(reminderDateCurrentYear, 1)) : currentYear;
  return reminderYear;
};

export const formatReminderDate = ({
  day,
  month,
  optionValue = 'The Day Of',
  reminderDay = '',
  reminderMonth = '',
}) => {
  if (!optionValue) return null;
  switch (optionValue) {
    case 'The Day Of':
      return { day, month, year: getReminderYear(day, month) };
    case 'The Day Before': {
      const reminderDate = sub(new Date(getReminderYear(day, month), MONTHS.indexOf(month), day), {
        years: 0,
        months: 0,
        weeks: 0,
        days: 1,
      });
      return { day: format(reminderDate, 'd'), month: MONTHS[getMonth(reminderDate)], year: getYear(reminderDate) };
    }
    case 'Two Weeks Before': {
      const reminderDate = sub(new Date(getReminderYear(day, month), MONTHS.indexOf(month), day), {
        years: 0,
        months: 0,
        weeks: 2,
        days: 0,
      });

      return { day: format(reminderDate, 'd'), month: MONTHS[getMonth(reminderDate)], year: getYear(reminderDate) };
    }
    case 'One Month Before': {
      const reminderDate = sub(new Date(getReminderYear(day, month), MONTHS.indexOf(month), day), {
        years: 0,
        months: 1,
        weeks: 0,
        days: 0,
      });
      return { day: format(reminderDate, 'd'), month: MONTHS[getMonth(reminderDate)], year: getYear(reminderDate) };
    }
    case 'Choose A Date':
      return { day: reminderDay, month: reminderMonth, year: getReminderYear(reminderDay, reminderMonth) };
    default:
      return { day, month, year: getReminderYear(day, month) };
  }
};

/**
 * Order provided wishlist array by date
 * @param {Array} wishlists
 * @returns {Array}
 */
export const orderWishlists = (wishlists) => {
  if (!wishlists.length) {
    return wishlists;
  }

  return _orderBy(
    wishlists,
    ({ created, updated }) => {
      const createdDate = new Date(created);
      const updatedDate = new Date(updated);
      // use the latest date for sorting
      return updatedDate.getTime() > createdDate.getTime() ? updatedDate : createdDate;
    },
    ['desc'],
  );
};

export const mapSpecialDateData = (data, fullName) => {
  const { title, day, month, year, id, reminderOption, reminderDay, reminderMonth } = data || {};
  const dataObj = {
    title,
    reminder: {},
    date: {
      day,
      month,
      year,
      dateId: id,
    },
  };
  const formattedReminderDate = formatReminderDate({
    day,
    month,
    optionValue: reminderOption,
    reminderDay,
    reminderMonth,
  });
  dataObj.reminder.title = `${fullName}'s ${title} on ${month} ${day}`;
  dataObj.reminder.date = { day: formattedReminderDate?.day, month: formattedReminderDate?.month };
  dataObj.reminder.option = reminderOption || 'The Day Of';

  return dataObj;
};
